globalThis.AutoFill = (function () {
  function AutoFill($html) {
    this.$scope = $html || $('body');
    this.init();
  }

  AutoFill.init = function ($html) {
    $html.each(function () {
      new AutoFill($(this));
    });
  };

  AutoFill.prototype = {
    init: function () {
      var module = this;

      this.$scope
        .on('change', 'select.sb-ad-auto-fill-trigger', function () {
          module.handleTrigger($(this));
        })
        .on('click', 'a.sb-ad-auto-fill-trigger', function () {
          module.handleTrigger($(this));
        });
    },
    handleTrigger: function ($trigger) {
      var data = this.getAutoFillData($trigger);
      if (data) this.apply(data);
    },
    getAutoFillData: function ($trigger) {
      if ($trigger.is('a[data-auto-fill]')) return $trigger.data('auto-fill');

      var $select = $trigger.is('select.sb-ad-auto-fill')
        ? $trigger
        : this.$scope.find('select.sb-ad-auto-fill');

      return $select.find('option:selected').data('auto-fill');
    },
    apply: function (autoFillData) {
      var $scope = this.$scope;

      $.each(autoFillData, function (fieldName, value) {
        var nameSelector = '[name*="[' + fieldName + ']"]';
        var $onOffContainer = $scope.find('.sb-ad-form-group-checkbox-onoff').filter(function () {
          return $(this).find('input[type="radio"]' + nameSelector).length > 0;
        });
        if ($onOffContainer.length) {
          var isCurrentlyOn = $onOffContainer.hasClass('on');
          var shouldBeOn = (value === true || value === 'true');
          if (isCurrentlyOn !== shouldBeOn) {
            $onOffContainer.trigger('click');
          }
          return;
        }

        var $radios = $scope.find('input[type="radio"]' + nameSelector);
        if ($radios.length) {
          $radios.filter('[value="' + value + '"]').prop('checked', true).trigger('change');
          return;
        }

        var $checkbox = $scope.find('input[type="checkbox"]' + nameSelector);
        if ($checkbox.length) {
          $checkbox.prop('checked', value === true || value === 'true').trigger('change');
          return;
        }

        var $targetSelect = $scope.find('select' + nameSelector);
        if ($targetSelect.length) {
          $targetSelect.val(value).trigger('change');
          return;
        }

        var $input = $scope.find('input' + nameSelector + ', textarea' + nameSelector);
        if ($input.length) {
          $input.val(value).trigger('change');
        }
      });
    }
  };

  return AutoFill;
})();
